import {
  DISPLAY_STYLE_HEADER,
  DISPLAY_STYLE_SHADED,
  DISPLAY_STYLE_BOLD,
  DISPLAY_STYLE_LEFT,
  DISPLAY_STYLE_RIGHT,
  DISPLAY_STYLE_RIGHT_ALIGN_STRING,
} from "components/Shared/MGridForm";
import {
  DATA_TYPE_STRING,
  DATA_TYPE_CHECKBOX,
  DATA_TYPE_RADIO,
  DATA_TYPE_SPLIT_RADIO,
  DATA_TYPE_DROPDOWN,
  DATA_TYPE_MULTI_LINE_STRING,
  DATA_TYPE_DATE,
} from "typeConstants/dataTypes";


//Returns true if the checkbox is checked.
const isChecked = (data, field) => typeof data[field] === "string" ? data[field].toLowerCase().startsWith("t") : data[field];

/*
Returns true if the conditions have been met to enable the entire Cost Approach section
By default, this section is disabled when form first loads
*/
// const costApproachEnabled = data => {
//   return data["cost-approach-required"] === "1" || isChecked(data, "cost-approach-mandated");
// };

/*
Returns true if the conditions have been met to enable the entire Income section
By default, this section is disabled when form first loads
*/
// const incomeApproachEnabled = data => {
//   return data["income-approach-required"] === "1";
// };

const comparableEnabled = (data, field) => {
  let i = parseInt(field.split("-")[2]);
  return i <= data["comparable-count"] && data[`comparable-enabled-${i}`];
};

//little hack for the title controls because they dont have sources
const comparableTitleEnabled = num => data => comparableEnabled(data, `--${num}`);

export const getEnabledKvpForElectricalServiceRepeat = i => {
  let enabledKvp = [];
  enabledKvp[`off-grid-service-${i}`] = data => ["Solar", "Generator", "Wind", "Hydro Electric"].includes(data[`electrical-service-2-${i}`]);
  enabledKvp[`solar-panel-ownership-${i}`] = data => data[`electrical-service-2-${i}`] === "Solar";
  return enabledKvp;
};
/*
Some fields should not be enabled until certain questions have been answered
Even then, said questions may need to be answered in specific ways
By default, these conditionally-enabled fields are disabled when the form first loads
this method enables the fields when necessary
*/
const shouldBeEnabled = (data, field) => {
  if (field === "FN-32") {
    return data["FN-29|FN-30|FN-31"] === "Other";
  }
  if (field === "FN-36") {
    return data["FN-33|FN-34|FN-35"] === "Other";
  }
  if (field === "FN-54" || field === "FN-56-1|FN-56-2|FN-56-3") {
    return data["FN-52|FN-53"] === "true";
  }
  if (field === "FA-92-3") {
    return data["FA-92-2"] === "Other";
  }
  if (field === "FA-92-5") {
    return data["FA-92-4"] === "Other";
  }
  if (field === "FN-101") {
    return data["FN-97|FN-98|FN-99|FN-100"] === "Illegal";
  }
  if (field === "FN-104-1|FN-104-2" || field === "Highest And Best Use If No Describe Label") {
    return data["FN-102|FN-103"] === "false";
  }
  if (field === "FN-107") {
    return data["FN-105|FN-106"] === "NonPublic";
  }
  if (field === "FN-110") {
    return data["FN-108|FN-109"] === "NonPublic";
  }
  if (field === "FN-113") {
    return data["FN-111|FN-112"] === "NonPublic";
  }
  if (field === "FN-116") {
    return data["FN-114|FN-115"] === "NonPublic";
  }
  if (field === "FN-130") {
    return data["FN-128|FN-129"] === "false";
  }
  if (field === "FN-133-1|FN-133-2|FN-133-3|FN-133-4|FN-133-5" || field === "Adverse Conditions If Yes Describe Label") {
    return data["FN-131|FN-132"] === "true";
  }
  if (field === "FA-164-2") {
    return data["FA-164-1"] === "Yes";
  }
  if (field === "FN-171" || field === "FN-172" || field === "FN-173" || field === "FN-174" || field === "FN-175" || field === "FN-176") {
    return !isChecked(data, "FN-170");
  }
  if (field === "FN-181") {
    return isChecked(data, "FN-180");
  }
  if (field === "FN-186") {
    return data["FN-183|FN-184|FN-185"] === "Other";
  }
  if (field === "FN-192") {
    return isChecked(data, "FN-191");
  }
  if (field === "FN-200") {
    return isChecked(data, "FN-199");
  }
  if (field === "FN-202" || field === "FN-205" || field === "FN-207" || field === "FA-209-1"
    || field === "FA-210-1" || field === "FA-211-1") {
    return !isChecked(data, "FN-201");
  }
  if (field === "FN-203" || field === "FN-204") {
    return (isChecked(data, "FN-202") && !isChecked(data, "FN-201"));
  }
  if (field === "FN-206") {
    return isChecked(data, "FN-205");
  }
  if (field === "FN-208" || field === "FA-209" || field === "FA-210" || field === "FA-211") {
    return (isChecked(data, "FN-207") && !isChecked(data, "FN-201"));
  }
  if (field === "FA-209-2") {
    return (isChecked(data, "FA-209-1") && !isChecked(data, "FN-201"));
  }
  if (field === "FA-210-2") {
    return (isChecked(data, "FA-210-1") && !isChecked(data, "FN-201"));
  }
  if (field === "FA-211-2") {
    return (isChecked(data, "FA-211-1") && !isChecked(data, "FN-201"));
  }
  if (field === "FN-228" || field === "FN-228-1") {
    return data["FN-226"] === "true";
  }
  if (field === "FN-229") {
    return (data["FN-226"] === "true" && (data["FN-228"] === "Updated" || data["FN-228"] === "Remodeled"));
  }
  if (field === "FN-229-1") {
    return (data["FN-226"] === "true" && (data["FN-228-1"] === "Updated" || data["FN-228-1"] === "Remodeled"));
  }
  if (field === "FN-233-1|FN-233-2|FN-233-3" || field === "Physical Deficiencies If Yes Describe Label") {
    return data["FN-231|FN-232"] === "true";
  }
  if (field === "FN-236-1|FN-236-2|FN-236-3|FN-236-4|FN-236-5|FN-236-6|FN-236-7|FN-236-8|FN-236-9|FN-236-10|FN-236-11|FN-236-12" || field === "General Conformity If No Describe Label") {
    return data["FN-234|FN-235"] === "false";
  }
  if (field === "FN-369-1|FN-369-2|FN-369-3") {
    return data["FN-367|FN-368"] === "false";
  }
  let condoSectionRequired = isChecked(data, "FN-25|FN-533");
  if (["FN-475", "FN-448|FN-449", "FN-443", "FN-445", "FN-446", "FN-510", "FN-511"].includes(field)) {
    return condoSectionRequired;
  }
  if (field === "FN-476") {
    return data["FN-475"] === "Condo" && condoSectionRequired;
  }
  if (field === "FN-125") {
    return data["FN-123|FN-124"] === "true";
  }
  //let pudSectionRequired = isChecked(data, "FN-25");

  // if (field === "FN-436|FN-437" || field === "FN-438|FN-439" ||
  //   field === "FN-441" || field === "FN-442" || field === "FN-443" ||
  //   field === "FN-444" || field === "FN-445" || field === "FN-446" || field === "FN-447" ||
  //   field === "FN-448|FN-449" || field === "FN-451|FN-452" || field === "FN-453" ||
  //   field === "FN-454|FN-455" || field === "FN-457|FN-458" || field === "FN-460" ||
  //   field === "Pud Section Label") {
  //   return pudSectionRequired;
  // }
  // if (field === "FN-450") {
  //   return (pudSectionRequired && (data["FN-448|FN-449"] === "true"));
  // }
  // if (field === "FN-456-1|FN-456-2|FN-456-3" || field === "Pud Completion Status Label") {
  //   return (pudSectionRequired && data["FN-454|FN-455"] === "false");
  // }
  // if (field === "FN-459-1|FN-459-2" || field === "Pud Rental Terms Label") {
  //   return (pudSectionRequired && data["FN-457|FN-458"] === "true");
  // }
  if (field === "cost-approach-required") {
    return !isChecked(data, "cost-approach-mandated");
  }

  return true;
};

//should be applied to any non-date fields that are required for submission
const fieldRequiredValidator = (data, field, value) => !value;

//should be applied to any date fields that are required for submission
const dateRequiredValidator = (data, field, value) => !value || value === "//";

//should be applied to any fields that require a whole number
const wholeNumberRequiredValidator = (data, field, value) => {
  if (value === null || value === "") return null;
  if (parseInt(value) == value) return null;
  else return "Field must be a whole number";
};

const wholeNumberRequiredOrUnkValidator = (data, field, value) => {
  let message = wholeNumberRequiredValidator(data, field, value);
  if (message && (!value || value.toLowerCase() !== "unk")) return "Field must be a whole number or Unk";
  return null;
};

const customValidator = (data, field) => {
  //foundation
  if (field === "FN-147" || field === "FN-148" || field === "FN-149" || field === "FN-150") {
    if (isChecked(data, "FN-147") || isChecked(data, "FN-148") || isChecked(data, "FN-149") || isChecked(data, "FN-150")) return null;

    return "A foundation must be selected(click save to refresh)";
  }

  //days on market
  if (field === "FN-41") {
    return (data["FN-39|FN-40"] !== "false" && !data["FN-41"]);
  }
};

// Commenting this because it is unused right now and lint throws error
// Still keeping it because there may be a use for it later

// const stringLengthValidator = len => (data, field, value) => {
//   if (!value) return null;
//   if (value.length <= len) return null;
//   else return `Max length: ${len} characters`;
// };

const combineValidator = (...validators) => {
  return (...params) => {
    for (const validator of validators) {
      let validation = validator(...params);
      if (validation) return validation;
    }
    return false;
  };
};

export default [
  [
    { label: "The purpose of this summary appraisal report is to provide the lender/client with an accurate, and adequately supported, opinion of the market value of the subject property." }
  ],
  [
    { label: "Subject", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Property Address", source: "FN-7", width: 50, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "City", source: "FN-8", width: 25, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "State", source: "FN-9", width: 10, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Zip Code", source: "FN-10", hasValidationError: fieldRequiredValidator },
  ],
  [
    { width: 75 },
    { dataType: DATA_TYPE_STRING, label: "County", source: "FN-13", hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Legal Description", source: "FN-14", hasValidationError: fieldRequiredValidator }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Assessor's Parcel #", source: "FN-15", width: 50, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Neighborhood Name", source: "FN-18", width: 50 },
  ],
  [
    { dataType: DATA_TYPE_RADIO, label: "For sale sign posted", source: "FN-508|FN-534", width: 36,
      dataTypeOptions: {
        options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }]
      }
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Occupant", source: "FN-21|FN-22|FN-23", width: 37, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: {
        options: [{ label: "Owner", value: "OwnerOccupied" }, { label: "Tenant", value: "TenantOccupied" }, { label: "Vacant", value: "Vacant" }]
      }
    },
    { dataType: DATA_TYPE_STRING, label: "HOA $", source: "FN-26", width: 8, hasValidationError: combineValidator(wholeNumberRequiredValidator, fieldRequiredValidator) },
    {
      dataType: DATA_TYPE_RADIO, source: "FN-27|FN-28", dataTypeOptions: {
        options: [{ label: "per year", value: "Annually" }, { label: "per month", value: "Monthly" }]
      }
    },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Property Rights Appraised", source: "FN-29|FN-30|FN-31", width: 44.25,
      dataTypeOptions: {
        options: [{ label: "Fee Simple", value: "FeeSimple" }, { label: "Leasehold", value: "Leasehold" }, { label: "Other (describe)", value: "Other" }]
      }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-32", enabled: shouldBeEnabled },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Lender/Client", source: "FN-37", width: 37, enabled: () => false },
    { dataType: DATA_TYPE_STRING, label: "Address", source: "FN-38", enabled: () => false },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Is the subject property currently offered for sale or has it been offered for sale in the twelve months prior to the effective date of this appraisal?", source: "FN-39|FN-40",
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] },
      width: 85, hasValidationError: fieldRequiredValidator
    },
    {
      dataType: DATA_TYPE_STRING, label: "Days on market", source: "FN-41", hasValidationError: combineValidator(wholeNumberRequiredOrUnkValidator, customValidator)
    }
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Report data source(s) used, offering price(s), and date(s).", source: "FN-42", hasValidationError: fieldRequiredValidator },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Is the subject property part of a homeowners or condo association?", source: "FN-25|FN-533", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    {
      dataType: DATA_TYPE_DROPDOWN, label: "Type", source: "FN-510", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Condo", value: "Condo" }, { label: "Homeowners", value: "Homeowners" }] }
    },
  ],
  [
    {
      dataType: DATA_TYPE_DROPDOWN, label: "HOA Status", source: "FN-511", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Active", value: "Active" }, { label: "Inactive", value: "Inactive" }] }
    },
    {}
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Number of units in the association", source: "FN-443", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator, },
    {}
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Approx. Number of units rented", source: "FN-445", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator, },
    { dataType: DATA_TYPE_STRING, label: "Number of units for sale", source: "FN-446", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator, },
    {}
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Building(s) converted for use as condos?", source: "FN-448|FN-449", labelWidth: 60, enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    {}
  ],







  [
    { label: "Market", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    { label: "Note: Race and the racial composition of the market are not appraisal factors.", style: { borderBottom: 3, className: DISPLAY_STYLE_BOLD } }
  ],
  [
    { label: "Market Characteristics", style: { className: DISPLAY_STYLE_SHADED, borderRight: 1 }, width: 50 },
    { label: "One-Unit Housing Trends", style: { className: DISPLAY_STYLE_SHADED, borderRight: 1 } },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Location", labelWidth: 19, width: 50, source: "FN-57|FN-58|FN-59",
      style: { borderRight: 1 },
      dataTypeOptions: { options: [{ label: "Urban", value: "Urban", width: 26 }, { label: "Suburban", value: "Suburban", width: 26 }, { label: "Rural", value: "Rural" }] },
      hasValidationError: fieldRequiredValidator
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Property Values", labelWidth: 26, source: "FN-66|FN-67|FN-68",
      style: { borderRight: 1 },
      dataTypeOptions: { options: [{ label: "Increasing", value: "Increasing", width: 27 }, { label: "Stable", value: "Stable", width: 22 }, { label: "Declining", value: "Declining" }] },
      hasValidationError: fieldRequiredValidator
    },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Built-Up", source: "FN-60|FN-61|FN-62", labelWidth: 19, width: 50,
      style: { borderRight: 1 },
      dataTypeOptions: {
        options: [{ label: "Over 75%", value: "Over75Percent", width: 26 }, { label: "25-75%", value: "25To75Percent", width: 26 }, { label: "Under 25%", value: "Under25Percent" }]
      },
      hasValidationError: fieldRequiredValidator
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Demand/Supply", source: "FN-69|FN-70|FN-71", labelWidth: 26,
      style: { borderRight: 1 },
      dataTypeOptions: { options: [{ label: "Shortage", value: "Shortage", width: 27 }, { label: "In Balance", value: "InBalance", width: 22 }, { label: "Over Supply", value: "OverSupply" }] },
      hasValidationError: fieldRequiredValidator
    },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Growth", source: "FN-63|FN-64|FN-65", labelWidth: 19, width: 50,
      style: { borderRight: 1 },
      dataTypeOptions: { options: [{ label: "Rapid", value: "Rapid", width: 26 }, { label: "Stable", value: "Stable", width: 26 }, { label: "Slow", value: "Slow" }] },
      hasValidationError: fieldRequiredValidator
    },
    {
      dataType: DATA_TYPE_RADIO, label: "Marketing Time", source: "FN-72|FN-73|FN-74", labelWidth: 26,
      style: { borderRight: 1 },
      dataTypeOptions: {
        options: [{ label: "Under 3 mths", value: "UnderThreeMonths", width: 27 }, { label: "3-6 mths", value: "ThreeToSixMonths", width: 22 }, { label: "Over 6 mths", value: "OverSixMonths" }]
      },
      hasValidationError: fieldRequiredValidator
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Neighborhood Boundaries", source: "FN-86-1|FN-86-2", style: { borderRight: 1 }, hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Neighborhood Description", source: "neighborhood-description-1|neighborhood-description-2|neighborhood-description-3|neighborhood-description-4|neighborhood-description-5|neighborhood-description-6|neighborhood-description-7", hasValidationError: fieldRequiredValidator },
  ],
  [
    { label: "Site", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Dimensions", source: "FN-89", width: 37, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Area", source: "FN-90", width: 21, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Shape", source: "FN-91", width: 21, hasValidationError: fieldRequiredValidator },
    {},
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Specific Zoning Classification", source: "FN-95", width: 37, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Zoning Description", source: "FN-96", hasValidationError: fieldRequiredValidator },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Zoning Compliance", source: "FN-97|FN-98|FN-99|FN-100", width: 62.5, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Legal", value: "Legal" }, { label: "Legal Nonconforming (Grandfathered Use)", value: "Nonconforming" }, { label: "No Zoning", value: "NoZoning" }, { label: "Illegal (describe)", value: "Illegal" }] }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-101", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    {
      dataType: DATA_TYPE_DROPDOWN, label: "Property Type:", source: "FN-501", width: 33.34, hasValidationError: fieldRequiredValidator, 
      dataTypeOptions: {
        options: [
          { label: "Commercial", value: "Commercial" },
          { label: "Condo", value: "Condo" },
          { label: "CondoTel", value: "CondoTel" },
          { label: "Co-op", value: "Co-op" },
          { label: "Land Only", value: "Land Only" },
          { label: "Manufactured", value: "Manufactured" },
          { label: "Mobile/Land Attached", value: "Mobile/Land Attached" },
          { label: "Modular", value: "Modular" },
          { label: "Multi-Family", value: "Multi-Family" },
          { label: "2-unit; Multi-Family", value: "2-unit; Multi-Family" },
          { label: "3-unit; Multi-Family", value: "3-unit; Multi-Family" },
          { label: "4-unit; Single Family Attached", value: "4-unit; Single Family Attached" },
          { label: "Single Family Detached", value: "Single Family Detached" },
          { label: "Townhome", value: "Townhome" }
        ]
      }
    },
    {
      dataType: DATA_TYPE_DROPDOWN, label: "Current Use:", source: "current-use", width: 33.33, hasValidationError: fieldRequiredValidator, 
      dataTypeOptions: {
        options: [
          { label: "Commercial", value: "Commercial" },
          { label: "Condo", value: "Condo" },
          { label: "CondoTel", value: "CondoTel" },
          { label: "Co-op", value: "Co-op" },
          { label: "Land Only", value: "Land Only" },
          { label: "Manufactured", value: "Manufactured" },
          { label: "Mobile/Land Attached", value: "Mobile/Land Attached" },
          { label: "Modular", value: "Modular" },
          { label: "Multi-Family", value: "Multi-Family" },
          { label: "2-unit; Multi-Family", value: "2-unit; Multi-Family" },
          { label: "3-unit; Multi-Family", value: "3-unit; Multi-Family" },
          { label: "4-unit; Single Family Attached", value: "4-unit; Single Family Attached" },
          { label: "Single Family Detached", value: "Single Family Detached" },
          { label: "Townhome", value: "Townhome" }
        ]
      }
    },
    {
      dataType: DATA_TYPE_DROPDOWN, label: "Highest and Best Use:", source: "highest-and-best-use", width: 33.33, hasValidationError: fieldRequiredValidator, 
      dataTypeOptions: {
        options: [
          { label: "Commercial", value: "Commercial" },
          { label: "Condo", value: "Condo" },
          { label: "CondoTel", value: "CondoTel" },
          { label: "Co-op", value: "Co-op" },
          { label: "Land Only", value: "Land Only" },
          { label: "Manufactured", value: "Manufactured" },
          { label: "Mobile/Land Attached", value: "Mobile/Land Attached" },
          { label: "Modular", value: "Modular" },
          { label: "Multi-Family", value: "Multi-Family" },
          { label: "2-unit; Multi-Family", value: "2-unit; Multi-Family" },
          { label: "3-unit; Multi-Family", value: "3-unit; Multi-Family" },
          { label: "4-unit; Single Family Attached", value: "4-unit; Single Family Attached" },
          { label: "Single Family Detached", value: "Single Family Detached" },
          { label: "Townhome", value: "Townhome" }
        ]
      }
    }
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, width: 76.7, label: "Is the highest and best use of the subject property as improved (or as proposed per plans and specifications) the present use?", source: "FN-102|FN-103", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { label: "If No, describe", source: "Highest And Best Use If No Describe Label", enabled: shouldBeEnabled },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-104-1|FN-104-2", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  // Example of dynamic number of repeat elements
  // This defines where the repeat should be situated in the form and how it should be displayed
  // All the common properties between the repeats are defined here like dataType, label and options
  // Source could be anything as it is only used to reference this definition in the Appraisal1004p component
  // All the data dependent properties are added in the Appraisal1004p component
  [
    {
      dataType: DATA_TYPE_DROPDOWN, label: "Electrical service", source: "electrical-service-2",
      dataTypeOptions: {
        options: [{ label: "Solar", value: "Solar" }, { label: "Public", value: "Public" }, { label: "Generator", value: "Generator" },
        { label: "Wind", value: "Wind" }, { label: "Hydro Electric", value: "Hydro Electric" }, { label: "No Electrical Service", value: "No Electrical Service" }]
      }
    },
    { dataType: DATA_TYPE_CHECKBOX, label: "This is an off-grid service", source: "off-grid-service" },
    {
      dataType: DATA_TYPE_DROPDOWN, label: "Solar panel ownership", source: "solar-panel-ownership",
      dataTypeOptions: {
        options: [{ label: "Homeowner owned", value: "Homeowner owned" }, { label: "Lease", value: "Lease" },
        { label: "Power purchase agreement", value: "Power purchase agreement" }, { label: "Financed", value: "Financed" }]
      }
    },
  ],
  [
    { label: "Utilities", width: 7.7, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Public", width: 5.2, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Other (describe)", width: 31, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Public", width: 5.2, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Other (describe)", width: 20, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Off-site Improvements—Type", width: 20.4, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Public", width: 5.7, style: { className: DISPLAY_STYLE_BOLD } },
    { label: "Private", style: { className: DISPLAY_STYLE_BOLD } },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Electricity", source: "FN-105|FN-106", labelWidth: 54, width: 17, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ value: "Public", width: 32 }, { value: "NonPublic" }] }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-107", width: 15.6, enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
    {
      dataType: DATA_TYPE_RADIO, label: "Water", source: "FN-111|FN-112", labelWidth: 62, width: 20.2, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ value: "Public", width: 28.4 }, { value: "NonPublic" }] }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-113", width: 16.3, enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Street", source: "FN-117", width: 20.9 },
    {
      dataType: DATA_TYPE_RADIO, source: "FN-118|FN-119", labelWidth: 69, enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ value: "Public", width: 67 }, { value: "Private" }] }
    },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Gas", source: "FN-108|FN-109", labelWidth: 54, width: 17, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ value: "Public", width: 32 }, { value: "NonPublic" }] }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-110", width: 15.6, enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
    {
      dataType: DATA_TYPE_RADIO, label: "Sanitary Sewer", source: "FN-114|FN-115", labelWidth: 62, width: 20.2, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ value: "Public", width: 28.4 }, { value: "NonPublic" }] }
    },
    { dataType: DATA_TYPE_STRING, source: "FN-116", width: 16.3, enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Alley", source: "FN-120", width: 20.9 },
    {
      dataType: DATA_TYPE_RADIO, source: "FN-121|FN-122", labelWidth: 69, enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ value: "Public", width: 67 }, { value: "Private" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Utility comments", source: "utility-comments-1|utility-comments-2", enabled: shouldBeEnabled }
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "FEMA Special Flood Hazard Area", source: "FN-123|FN-124", width: 30,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "FEMA Flood Zone", source: "FN-125", width: 20, enabled: shouldBeEnabled },
    { width: 50, style: { borderLeft: 1 } },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Are the utilities and off-site improvements typical for the market area?", source: "FN-128|FN-129", width: 51.7, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "If No, describe", source: "FN-130", enabled: shouldBeEnabled },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Are there any adverse site conditions or external factors (easements, encroachments, environmental conditions, land uses, etc.)?", source: "FN-131|FN-132", width: 78, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { label: "If Yes, describe", source: "Adverse Conditions If Yes Describe Label", enabled: shouldBeEnabled },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-133-1|FN-133-2|FN-133-3|FN-133-4|FN-133-5", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { label: "Improvements", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    { label: "General Description", width: 25, style: { className: DISPLAY_STYLE_SHADED, borderRight: 2 } },
    { label: "Foundation", width: 25, style: { className: DISPLAY_STYLE_SHADED, borderRight: 2 }, hasValidationError: fieldRequiredValidator },
    { label: "Exterior Description", width: 13.9, style: { className: [DISPLAY_STYLE_SHADED, DISPLAY_STYLE_LEFT] } },
    { label: "materials/condition", width: 13.9, style: { className: [DISPLAY_STYLE_SHADED, DISPLAY_STYLE_RIGHT], borderRight: 2 } },
    { label: "Interior", width: 10, style: { className: [DISPLAY_STYLE_SHADED, DISPLAY_STYLE_LEFT] } },
    { label: "materials/condition", style: { className: [DISPLAY_STYLE_SHADED, DISPLAY_STYLE_RIGHT] } },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Units", source: "FN-134|FN-135", width: 25, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "One", value: "false" }, { label: "One with Accessory Unit", value: "true" }], hasValidationError: fieldRequiredValidator }
    },
    { dataType: DATA_TYPE_CHECKBOX, label: "Concrete Slab", source: "FN-147", width: 12, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Crawl Space", source: "FN-148", width: 13, style: { borderRight: 2 }, hasValidationError: customValidator },
    { dataType: DATA_TYPE_STRING, label: "Foundation Walls", source: "FA-158-1", width: 20.5, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-158-2", width: 6.0, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Floors", source: "FA-165-1", width: 15, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-165-2", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "# of Stories", source: "FN-136", width: 25, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Full Basement", source: "FN-149", width: 12, hasValidationError: customValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Partial Basement", source: "FN-150", width: 13, style: { borderRight: 2 }, hasValidationError: customValidator },
    { dataType: DATA_TYPE_STRING, label: "Exterior Walls", source: "FA-159-1", width: 20.5, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-159-2", width: 6.0, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Walls", source: "FA-166-1", width: 15, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1, hasValidationError: fieldRequiredValidator },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-166-2", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Type", source: "FN-137|FN-138|FN-139", width: 25, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Det.", value: "Detached" }, { label: "Att.", value: "Attached" }, { label: "S-Det./End Unit", value: "SemiDetached" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Basement Area", source: "FN-151", width: 20, hasValidationError: fieldRequiredValidator },
    { label: "sq. ft.", width: 5, style: { borderRight: 2 } },
    { dataType: DATA_TYPE_STRING, label: "Roof Surface", source: "FA-160-1", width: 20.5, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-160-2", width: 6.0, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Trim/Finish", source: "FA-167-1", width: 15, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-167-2", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "None", value: "None" }, { label: "N/A", value: "N/A" }] }
    },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, source: "FN-140|FN-141|FN-142", width: 25, style: { borderRight: 2 },
      dataTypeOptions: { options: [{ label: "Existing", value: "Existing" }, { label: "Proposed", value: "Proposed" }, { label: "Under Const.", value: "UnderConstruction" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Basement Finish", source: "FN-152", width: 22.8, hasValidationError: fieldRequiredValidator },
    { label: "%", width: 2.2, style: { borderRight: 2 } },
    { dataType: DATA_TYPE_STRING, label: "Gutters & Downspouts", source: "FA-161-1", width: 20.5, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-161-2", width: 6.0, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Bath Floor", source: "FA-168-1", width: 15, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-168-2", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Design (Style)", source: "FN-143", width: 25, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Outside Entry/Exit", source: "FA-153", width: 14 },
    { dataType: DATA_TYPE_CHECKBOX, label: "Sump Pump", source: "FN-154", width: 11, style: { borderRight: 2 } },
    { dataType: DATA_TYPE_STRING, label: "Window Type", source: "FA-162-1", width: 20.5, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-162-2", width: 6.0, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "N/A", value: "N/A" }] }
    },
    { dataType: DATA_TYPE_STRING, label: "Bath Wainscot", source: "FA-169-1", width: 15, style: { borderBottom: 3 }, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1, style: { borderBottom: 3 } },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-169-2", style: { borderBottom: 3 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "None", value: "None" }, { label: "N/A", value: "N/A" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Year Built", source: "FN-145", width: 12, hasValidationError: combineValidator(wholeNumberRequiredOrUnkValidator, fieldRequiredValidator) },
    {
      dataType: DATA_TYPE_DROPDOWN, label: "Estimated", source: "FN-144", width: 13.01, hasValidationError: fieldRequiredValidator, style: { borderRight: 2 },
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] }
    },
    { label: "Evidence of", width: 12 },
    { dataType: DATA_TYPE_CHECKBOX, label: "Infestation", source: "FN-155", width: 13, style: { borderRight: 2 } },
    { dataType: DATA_TYPE_STRING, label: "Storm Sash/Insulated", source: "FA-163-1", width: 20.5, hasValidationError: fieldRequiredValidator },
    { label: "/", width: 1 },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-163-2", width: 6.0, style: { borderRight: 3 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "None", value: "None" }, { label: "N/A", value: "N/A" }] }
    },
    { label: "Car Storage", width: 9.3, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "None", source: "FN-201" },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Effective Age (Yrs)", source: "FN-146", width: 25, style: { borderRight: 2, borderBottom: 3 }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Dampness", source: "FN-156", width: 12, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Settlement", source: "FN-157", width: 13, style: { borderRight: 2, borderBottom: 3 } },

    { label: "Screens", width: 15, style: { borderBottom: 3 } },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-164-1", width: 5.5, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Yes", value: "Yes" }, { label: "No", value: "None" }] },
      style: { borderBottom: 3 }
    },
    { label: "/", width: 1, style: { borderBottom: 3 } },
    {
      dataType: DATA_TYPE_DROPDOWN, source: "FA-164-2", width: 6.0, enabled: shouldBeEnabled, style: { borderRight: 3, borderBottom: 3 }, hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "Excellent", value: "Exlnt" }, { label: "Good", value: "Good" }, { label: "Avg", value: "Avg" }, { label: "Fair", value: "Fair" }, { label: "Poor", value: "Poor" }, { label: "None", value: "None" }] }
    },
    { dataType: DATA_TYPE_CHECKBOX, label: "Driveway", source: "FN-202", width: 9.3, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_STRING, label: "# of Cars", source: "FN-203", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { label: "Attic", width: 13 },
    { dataType: DATA_TYPE_CHECKBOX, label: "None", source: "FN-170", width: 12.01, style: { borderRight: 2 }, dataTypeOptions: { checkedValue: "true", uncheckedValue: "false" }, hasValidationError: fieldRequiredValidator }, //12.01 width because i was having a pixel rounding issue :(
    { label: "Heating", width: 5.2 },
    { dataType: DATA_TYPE_CHECKBOX, label: "FWA", source: "FN-177", width: 5.5, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "HWBB", source: "FN-178", width: 6.7, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Radiant", source: "FN-179", width: 7.6, style: { borderRight: 2 } },
    { label: "Amenities", width: 13.3 },
    { dataType: DATA_TYPE_CHECKBOX, label: "Woodstove(s)", source: "FN-193", width: 10 },
    { dataType: DATA_TYPE_STRING, label: "#", source: "FN-194", width: 4.5, style: { borderRight: 2 } },
    { dataType: DATA_TYPE_STRING, label: "Driveway Surface", source: "FN-204", enabled: shouldBeEnabled },
  ],
  [
    { dataType: DATA_TYPE_CHECKBOX, label: "Drop Stair", source: "FN-171", width: 13, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_CHECKBOX, label: "Stairs", source: "FN-172", width: 12.01, style: { borderRight: 2 }, enabled: shouldBeEnabled }, //12.01 width because i was having a pixel rounding issue :(
    { dataType: DATA_TYPE_CHECKBOX, label: "Other", source: "FN-180", width: 6.1 },
    { dataType: DATA_TYPE_STRING, source: "FN-181", width: 6.4, style: { borderRight: 1 }, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_STRING, label: "Fuel", source: "FN-182", width: 12.5, style: { borderRight: 2 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Fireplace(s)", source: "FN-187", width: 9.3 },
    { dataType: DATA_TYPE_STRING, label: "#", source: "FN-188", width: 4 },
    { dataType: DATA_TYPE_CHECKBOX, label: "Fence", source: "FN-195", width: 6.3 },
    { dataType: DATA_TYPE_STRING, source: "FN-196", width: 8.2, style: { borderRight: 2 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Att. Garage", source: "FA-209-1", width: 9.3, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_STRING, label: "# of Cars", source: "FA-209-2", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_CHECKBOX, label: "Floor", source: "FN-173", width: 13, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_CHECKBOX, label: "Scuttle", source: "FN-174", width: 12.01, style: { borderRight: 2 }, enabled: shouldBeEnabled }, //12.01 width because i was having a pixel rounding issue :(
    { label: "Cooling", width: 6.1 },
    { dataType: DATA_TYPE_SPLIT_RADIO, label: "Central Air Conditioning", value: "Central Air Conditioning", source: "FN-183|FN-184|FN-185", width: 18.9, style: { borderRight: 2 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Patio/Deck", source: "FN-189", width: 8.9 },
    { dataType: DATA_TYPE_STRING, source: "FN-190", width: 4.4, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Porch", source: "FN-197", width: 6.3 },
    { dataType: DATA_TYPE_STRING, source: "FN-198", width: 8.2, style: { borderRight: 2 }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_CHECKBOX, label: "Det. Garage", source: "FA-210-1", width: 9.3, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_STRING, label: "# of Cars", source: "FA-210-2", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_CHECKBOX, label: "Finished", source: "FN-175", width: 13, style: { borderBottom: 3 }, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_CHECKBOX, label: "Heated", source: "FN-176", width: 12.01, style: { borderRight: 2, borderBottom: 3 }, enabled: shouldBeEnabled }, //12.01 width because i was having a pixel rounding issue :(
    { dataType: DATA_TYPE_SPLIT_RADIO, label: "Individual", value: "Individual", source: "FN-183|FN-184|FN-185", width: 12.5, style: { borderRight: 1, borderBottom: 3 } },
    { dataType: DATA_TYPE_SPLIT_RADIO, label: "Other", value: "Other", source: "FN-183|FN-184|FN-185", width: 5.9, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_STRING, source: "FN-186", width: 6.6, style: { borderRight: 2, borderBottom: 3 }, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_CHECKBOX, label: "Pool", source: "FN-191", width: 5.2, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_STRING, source: "FN-192", width: 8.1, style: { borderBottom: 3 }, enabled: shouldBeEnabled, },
    { dataType: DATA_TYPE_CHECKBOX, label: "Other", source: "FN-199", width: 6.3, style: { borderBottom: 3 } },
    { dataType: DATA_TYPE_STRING, source: "FN-200", width: 8.2, style: { borderRight: 2, borderBottom: 3 }, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_CHECKBOX, label: "Bltn Garage", source: "FA-211-1", width: 9.3, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_STRING, label: "# of Cars", source: "FA-211-2", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },

  ],
  [
    { width: 77.81, style: { borderRight: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Carport", source: "FN-207", width: 9.3, enabled: shouldBeEnabled },
    { dataType: DATA_TYPE_STRING, label: "# of Cars", source: "FN-208", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { width: 77.83, style: { borderRight: 3 } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Att.", source: "FA-209", width: 7.4, enabled: shouldBeEnabled, style: { borderBottom: 3 }, dataTypeOptions: { checkedValue: "Attached", uncheckedValue: null } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Det.", source: "FA-210", width: 7.4, enabled: shouldBeEnabled, style: { borderBottom: 3 }, dataTypeOptions: { checkedValue: "Detached", uncheckedValue: null } },
    { dataType: DATA_TYPE_CHECKBOX, label: "Built-in", source: "FA-211", enabled: shouldBeEnabled, style: { borderBottom: 3 }, dataTypeOptions: { checkedValue: "BuiltIn", uncheckedValue: null } },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Finished area above grade contains:", source: "FN-220", width: 30, style: { className: DISPLAY_STYLE_RIGHT_ALIGN_STRING }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Rooms", source: "FN-221", width: 12.8, style: { className: DISPLAY_STYLE_RIGHT_ALIGN_STRING }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Bedrooms", source: "FA-222", width: 12.8, style: { className: DISPLAY_STYLE_RIGHT_ALIGN_STRING }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "Bath(s)", source: "FN-223", width: 12.8, style: { className: DISPLAY_STYLE_RIGHT_ALIGN_STRING }, hasValidationError: fieldRequiredValidator },
    { label: "Square Feet of Gross Living Area Above Grade" }
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "Does the property generally conform to the neighborhood (functional utility, style, condition, use, construction, etc.)?",
      source: "FN-234|FN-235", width: 70,
      dataTypeOptions: { options: [{ label: "Yes", value: "true" }, { label: "No", value: "false" }] },
      hasValidationError: fieldRequiredValidator
    },
    { label: "If No, describe", source: "General Conformity If No Describe Label" },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, source: "FN-236-1|FN-236-2|FN-236-3|FN-236-4|FN-236-5|FN-236-6|FN-236-7|FN-236-8|FN-236-9|FN-236-10|FN-236-11|FN-236-12", enabled: shouldBeEnabled, hasValidationError: fieldRequiredValidator },
  ],
  [
    { label: "Sales Comparison Approach", style: { className: DISPLAY_STYLE_HEADER } }
  ],
  [
    { label: "Navigate to Comparables with Comparables Search Form to complete the Grid", style: { className: [DISPLAY_STYLE_SHADED, "comp-grid-placeholder"] } }
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "My research", source: "FN-370|FN-371", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "did", value: "true" }, { label: "did not reveal any prior sales or transfers of the subject property for the three years prior to the effective date of this appraisal.", value: "false" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Data Source(s)", source: "FN-372", hasValidationError: fieldRequiredValidator },
  ],
  [
    {
      dataType: DATA_TYPE_RADIO, label: "My research", source: "FN-373|FN-374", hasValidationError: fieldRequiredValidator,
      dataTypeOptions: { options: [{ label: "did", value: "true" }, { label: "did not reveal any prior sales or transfers of the comparable sales for the year prior to the date of sale of the comparable sale.", value: "false" }] }
    },
  ],
  [
    { dataType: DATA_TYPE_STRING, label: "Data Source(s)", source: "FN-375", hasValidationError: fieldRequiredValidator },
  ],
  [
    { label: "Report the results of the research and analysis of the prior sale or transfer history of the subject property and comparable sales (report additional prior sales on page 3)." },
  ],
  [
    { label: "ITEM", width: 19.4, style: { borderRight: 1 } },
    { label: "SUBJECT", width: 20, style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 1", width: 20, enabled: comparableTitleEnabled(1), style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 2", width: 20, enabled: comparableTitleEnabled(2), style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 3", enabled: comparableTitleEnabled(3) },
  ],
  [
    { label: "Date of Prior Sale/Transfer", width: 19.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-376", width: 20, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-1", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-2", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-3", enabled: comparableEnabled },
  ],
  [
    { label: "Price of Prior Sale/Transfer", width: 19.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-377", width: 20, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-1", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-2", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-3", enabled: comparableEnabled },
  ],
  [
    { label: "Data Source(s)", width: 19.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-378", width: 20, hasValidationError: fieldRequiredValidator, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-1", width: 20, hasValidationError: fieldRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-2", width: 20, hasValidationError: fieldRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-3", hasValidationError: fieldRequiredValidator, enabled: comparableEnabled },
  ],
  [
    { label: "Effective Date of Data Source(s)", width: 19.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-379", width: 20, hasValidationError: dateRequiredValidator, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-1", width: 20, hasValidationError: dateRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-2", width: 20, hasValidationError: dateRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-3", hasValidationError: dateRequiredValidator, enabled: comparableEnabled },
  ],
  [
    { label: "ITEM", width: 39.4, style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 4", width: 20, enabled: comparableTitleEnabled(4), style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 5", width: 20, enabled: comparableTitleEnabled(5), style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 6", enabled: comparableTitleEnabled(6) },
  ],
  [
    { label: "Date of Prior Sale/Transfer", width: 39.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-4", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-5", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-6", enabled: comparableEnabled },
  ],
  [
    { label: "Price of Prior Sale/Transfer", width: 39.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-4", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-5", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-6", enabled: comparableEnabled },
  ],
  [
    { label: "Data Source(s)", width: 39.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-4", width: 20, hasValidationError: fieldRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-5", width: 20, hasValidationError: fieldRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-6", hasValidationError: fieldRequiredValidator, enabled: comparableEnabled },
  ],
  [
    { label: "Effective Date of Data Source(s)", width: 39.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-4", width: 20, hasValidationError: dateRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-5", width: 20, hasValidationError: dateRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-6", hasValidationError: dateRequiredValidator, enabled: comparableEnabled },
  ],
  [
    { label: "ITEM", width: 39.4, style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 7", width: 20, enabled: comparableTitleEnabled(7), style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 8", width: 20, enabled: comparableTitleEnabled(8), style: { borderRight: 1 } },
    { label: "COMPARABLE SALE # 9", enabled: comparableTitleEnabled(9) },
  ],
  [
    { label: "Date of Prior Sale/Transfer", width: 39.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-7", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-8", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-380-9", enabled: comparableEnabled },
  ],
  [
    { label: "Price of Prior Sale/Transfer", width: 39.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-7", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-8", width: 20, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-381-9", enabled: comparableEnabled },
  ],
  [
    { label: "Data Source(s)", width: 39.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-7", width: 20, hasValidationError: fieldRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-8", width: 20, hasValidationError: fieldRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_STRING, source: "FN-382-9", hasValidationError: fieldRequiredValidator, enabled: comparableEnabled },
  ],
  [
    { label: "Effective Date of Data Source(s)", width: 39.4, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-7", width: 20, hasValidationError: dateRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-8", width: 20, hasValidationError: dateRequiredValidator, enabled: comparableEnabled, style: { borderRight: 1 } },
    { dataType: DATA_TYPE_DATE, source: "FA-383-9", hasValidationError: dateRequiredValidator, enabled: comparableEnabled },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Analysis of prior sale or transfer history of the subject property and comparable sales", source: "FN-384-1|FN-384-2|FN-384-3|FN-384-4|FN-384-5|FN-384-6", hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, label: "Summary of Sales Comparison Approach", source: "FN-385-1|FN-385-2|FN-385-3|FN-385-4|FN-385-5|FN-385-6|FN-385-7|FN-385-8|FN-385-9|FN-385-10|FN-385-11|FN-385-12|FN-385-13|FN-385-14", hasValidationError: fieldRequiredValidator },
  ],
  [
    { label: "Reconciliation", style: { className: DISPLAY_STYLE_HEADER } },
  ],
  [
    { label: "Indicated Value by:", width: 13, style: { className: DISPLAY_STYLE_BOLD } },
    { dataType: DATA_TYPE_STRING, label: "As Is $", source: "FN-396", width: 28.6, style: { className: DISPLAY_STYLE_BOLD }, hasValidationError: fieldRequiredValidator },
    { dataType: DATA_TYPE_STRING, label: "As Repaired $", source: "FN-522", width: 28.2, style: { className: DISPLAY_STYLE_BOLD }, hasValidationError: fieldRequiredValidator },
  ],
  [
    { dataType: DATA_TYPE_DATE, label: "as of", source: "FA-397", width: 17, hasValidationError: dateRequiredValidator, style: { className: DISPLAY_STYLE_BOLD } },
    { label: ", which is the date of inspection and the effective date of this appraisal.", style: { className: DISPLAY_STYLE_BOLD } },
  ],
  [
    { label: "Exposure Time: A reasonable exposure time for this property is", width: 41.5, style: { className: DISPLAY_STYLE_BOLD } },
    { dataType: DATA_TYPE_STRING, label: "Exposure days range START:", source: "FA-exposure-start", width: 28.5, hasValidationError: combineValidator(wholeNumberRequiredValidator, fieldRequiredValidator) },
    { dataType: DATA_TYPE_STRING, label: "Exposure days range END:", source: "FA-exposure-end", hasValidationError: combineValidator(wholeNumberRequiredValidator, fieldRequiredValidator) }
  ],
  [
    { label: "Additional Comments", style: { className: DISPLAY_STYLE_HEADER } },
  ],
  [
    { dataType: DATA_TYPE_MULTI_LINE_STRING, dataTypeOptions: { defaultLines: 10 }, source: "FN-402-1|FN-402-2|FN-402-3|FN-402-4|FN-402-5|FN-402-6|FN-402-7|FN-402-8|FN-402-9|FN-402-10|FN-402-11|FN-402-12|FN-402-13|FN-402-14|FN-402-15|FN-402-16|FN-402-17|FN-402-18|FN-402-19|FN-402-20|FN-402-21|FN-402-22|FN-402-23|FN-402-24|FN-402-25|FN-402-26|FN-402-27|FN-402-28|FN-402-29|FN-402-30|FN-402-31|FN-402-32|FN-402-33|FN-402-34|FN-402-35|FN-402-36|FN-402-37|FN-402-38|FN-402-39|FN-402-40|FN-402-41|FN-402-42|FN-402-43|FN-402-44|FN-402-45|FN-402-46|FN-402-47|FN-402-48|FN-402-49|FN-402-50|FN-402-51|FN-402-52|FN-402-53|FN-402-54|FN-402-55|FN-402-56|FN-402-57|FN-402-58|FN-402-59|FN-402-60|FN-402-61|FN-402-62|FN-402-63|FN-402-64|FN-402-65|FN-402-66|FN-402-67|FN-402-68|FN-402-69|FN-402-70|FN-402-71|FN-402-72|FN-402-73|FN-402-74" },
  ],
  [
    {},
  ],
];